import { ReactiveFormsModule } from '@angular/forms';
import { CockpitPushButton } from './PushButton/pushButton.component';
import { CockpitToggleButton } from  './ToggleButton/toggle-button.component';
import { CockpitEmptyCellButton } from './EmptyCell/empty-cell-component';
import { GridComponent } from '../cockpitDesigner/cockpitDesigner.models';
import { PushButtonFormComponent } from  '../cockpitComponents/PushButton/PushButtonFom/PushButtonForm.component';


export const  Components = {
  pushButton: CockpitPushButton,
  toggleButton: CockpitToggleButton,
  emptyCell: CockpitEmptyCellButton,
} as const


export const ComponentForms = {
  pushButton: PushButtonFormComponent,
  toggleButton: PushButtonFormComponent,
  emptyCell: PushButtonFormComponent
}

export interface ComponentInputs {
  label?: string;
  checked?: boolean;

  // ...other possible inputs
}

export type ComponentKey = keyof typeof Components;
export interface ComponentConfig {
  type: ComponentKey;
  inputs?: ComponentInputs
  defaultItem: GridComponent
}

export const componentList: ComponentConfig[] = [
  {
    type: 'pushButton',
    inputs: {
      label: 'Push Button',
      checked: false,
    },
    defaultItem: {
      id: new Date().getMilliseconds().toString(),
      name: 'pushButton',
      position: 1,
      componentSettings: {
        componentId: 'enter Id here',
        componentName: ' my component'
      }
    }
  },
  {
    type: 'toggleButton',
    inputs: {
      label: 'Toggle Button',
      checked: false
    },
    defaultItem: {
      id: new Date().getMilliseconds().toString()+'21',
      name: 'toggleButton',
      position: 1,
      componentSettings: {
        componentId: 'enter Id here',
        componentName: ' my component'
      }
    }
  }
];

